<template>

  <div class="card" v-if="cardData">
    <div class="solid" :class="{orange: cardData.stockStatus === 1 || cardData.stockStatus === 2, red: cardData.stockStatus === 3}"></div>
    <div class="wrap">
      <div class="content">
        <h3 class="title" @click="readHouseDetail(cardData.stockFid)">
          <p>{{cardData.stockNumber+ '-' +cardData.houseTypeName}}</p>
          <p
            class="stock-str-position"
            :class="{highlight: [2, 3].includes(cardData.stockIsOrder) || cardData.stockStatus === 3}"
          >
            {{cardData.stockIsOrderStr}}
          </p>
        </h3>
        <div class="text">

          <p><span>{{formatMoney(cardData.stockRentPrice)}}</span>元/<span>月</span></p>

          <p class="type">
            <span>{{cardData.houseTypeRooms +'室'+ cardData.houseTypeHall+'厅' + cardData.houseTypeBathroom+'卫'+' | '+getDirStr(cardData.stockDirection)+' | '+cardData.stockArea+'m²'}}</span>
          </p>

          <p class="status" v-if="displayConfigRentDate">
            {{'可出租日期：'+ formatDateTime(cardData.configRentDate, false)}}<span class="font-red" v-if="cardData.configOverTime"> 配置超期</span>
          </p>

          <p class="status" v-if="displayReservationSignDate">
            <span>{{`合同预计签署日：${formatDateTime(cardData.reservationSignDate, false)}`}}</span>
          </p>

          <p class="status" v-if="displayStockVacancyDay">
            <span>{{`空置：${cardData.stockVacancyDay}天`}}</span>
          </p>

          <p class="status" v-if="displayStockRentDate">
            <span>{{'合同到期日：'+ formatDateTime(cardData.stockRentDate,false)}}</span>
          </p>

          <p class="status" v-if="rentType === 1">
            <span>{{'性别限制:'+cardData.limitLabelStr}}</span>
          </p>

          <!-- <p v-if="cardData.stockStatus !==1 && cardData.stockVacancyDay !==null && cardData.stockVacancyDay >= 0" class="status">
            <span v-if="cardData.stockIsOrder === 2 || cardData.stockIsOrder === 3">{{`合同预计签署日：${formatDateTime(cardData.reservationSignDate, false)}`}}</span>
            <span v-else>{{'合同到期日：'+ formatDateTime(cardData.stockRentDate,false)}}</span>
            {{`空置：${cardData.stockVacancyDay}天`}}
          </p>
          <p v-if="cardData.stockStatus === 3 && cardData.configRentDate" class="status">
            {{'可出租日期：'+ formatDateTime(cardData.configRentDate, false)}}
          </p> -->
        </div>
      </div>
      <div class="avatar-wrap" v-if="cardData.stockStatus===1&&cardData.stockIsOrder!==2">
        <div class="avatar" >
          <Icon type="person" size="18" color="#fff"></Icon>
        </div>
      </div>
      <div class="operate-buttons" v-if="cardData.stockStatus === 0 || cardData.stockStatus === 3">
        <div class="opreate-item item1" @click.stop="sendInvitations()" v-p="{api:'signinvite/saveSignInviteInfo'}">
          <div class="tip">{{`发送邀请(${cardData.stockSignInviteNum})`}}</div>
          <div class="square" style="font-size: 12px;cursor: pointer">签
          </div>
        </div>
      </div>
      <div class="item2 book-operate" v-if="false">
      <!-- <div class="item2 book-operate" v-if="cardData.isShowOrder===1"> -->
        <div class="tip2">预定房源</div>
        <div  @click.stop="bookPerson(cardData)" style="cursor: pointer;background-color: white;width: 100%;height: 100%">订</div>
      </div>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import {formatDateTime,formatMoney} from "@/utils/format";
  import invite from '@/assets/invite@2x.png';
  import inviteHover from '@/assets/invite-hover@2x.png';
  import {lockStock} from 'api/house';
  export default {
    name:'Card',
    props :{
      cardData:{
        type:Object,
        default:null
      },
      projectFid:{
        type:String,
        default:''
      },
      rentType: {
        type: Number,
        default: 0,
      }
    },
    computed: {
      // 可出租日期
      displayConfigRentDate () {
        const { stockStatus, stockIsOrder } = this.cardData;
        return stockStatus === 3 && [0, 1].includes(stockIsOrder);
      },
      // 合同预计签署日
      displayReservationSignDate () {
        const { stockStatus, stockIsOrder } = this.cardData;
        return [2, 3].includes(stockIsOrder) && [0, 1, 2, 3].includes(stockStatus);
      },
      // 空置时长
      displayStockVacancyDay () {
        const { stockStatus, stockIsOrder } = this.cardData;
        return [0, 2].includes(stockStatus) && [0, 1].includes(stockIsOrder);
      },
      // 合同到期日
      displayStockRentDate () {
        const { stockStatus, stockIsOrder } = this.cardData;
        return stockStatus === 1 && [0, 1].includes(stockIsOrder);
      },
    },
    data () {
      return {
        invite:invite

      };
    },
    methods:{
      bookPerson(cardData){
        this.$emit('personbook',cardData)
      },
      formatDateTime:formatDateTime,
      formatMoney:formatMoney,
      getDirStr(dirCode) {
        let str = '';
        switch(dirCode) {
          case 1:
            str='东';
            break;
          case 2:
            str='南';
            break;
          case 3:
            str='西';
            break;
          case 4:
            str='北';
            break;
          case 5:
            str='人造天井';
            break;
          case 6:
            str='西南';
            break;
          case 7:
            str='东南';
            break;
          case 8:
            str='东北';
            break;
          case 9:
            str='西北';
            break;
          default:
            str='其他'
        }
        return str
      },
      readHouseDetail(stockFid){
        this.$router.push({ name: 'housedetail', params: {stockFid:stockFid }})
      },
      sendInvitations(){
        const {
          stockFid,
          stockNumber,
          stockStatus,
        } = this.cardData;
        const { projectFid } = this;
        if (stockStatus === 3) {
          this.$Modal.confirm({
            content: '房态状态为配置中，确认修改为待租中，并继续签约吗？',
            onOk: () => {
              lockStock({stockFid, projectFid, lockOrUnLock: 0}).then(res => {
                if (res.code === 0) {
                  this.$emit('send-invitations', {stockFid, stockNumber});
                } else {
                  this.$Message.warning('修改房间状态失败');
                }
              }).catch(error => {})
            }
          })
        } else {
          this.$emit('send-invitations', {stockFid, stockNumber});
        }
      }
    }
  }
</script>

<style lang="css" scoped>
  .top-tip{
    position: relative;
    right: 18px;
    font-weight: bold;
    color: #7D8699;


  }
  .book-operate{

    position: absolute;
    bottom: -13px;
    right: 40px;

    display: inline-block;
    width: 26px;
    height: 26px;
    background: #fff;
    border: 1px solid #DDDEE1;
    text-align: center;
    line-height: 26px;
    border-radius: 2px;
  }

  .card {
    display: flex;
    width:100%;
    border-radius: 2px;
    background: #FFFFFF;
    box-sizing: border-box;
    /*overflow: hidden;*/
    box-shadow: 1px 1px 4px rgba(0,0,0,0.08);
    margin-bottom: 24px;
  }
  .solid {
    width: 4px;
    background: #86BA7B;
  }
  .wrap {
    position: relative;
    flex: 1;
    display: flex;
    border: 1px solid #DFDFDF;
    border-left-width: 0;
    padding: 18px 18px 18px 23px;
    position: relative;
  }

  .title{
    cursor: pointer;
    font-size: 12px;
    color: #495060;
    letter-spacing: 0;
    line-height: 12px;
    width: 90%;
  }
  .stock-str-position{
    position: absolute;
    right: 20px;
    top: 18px;
  }
  .stock-str-position.highlight{
    color: rgb(254, 163, 50);
  }
  .title:hover {
    opacity: .8;
  }
  .text {
    margin-top: 18px;
    font-size: 12px;
    color: #999;
    line-height: 1.5;
  }
  .text .font-red{
    color: red;
  }
  .content {
    flex: 1;
  }
  .avatar-wrap{
    position: absolute;
    top: 10px;
    right: -8px;
  }
  .avatar{
    width:27px;
    height: 27px;
    line-height: 27px;
    text-align: center;
    position: absolute;
    right: 17px;
    border-radius: 50%;
    background: #E0E0E0;
    border: 1px solid #CCC;
    overflow: hidden;

  }
  .avatar img {
    width: 100%;
    height: 100%;
  }
  .orange {
    background: #CFA868;
  }
  .red {
    background: red;
  }
  .square{
    display: inline-block;
    width: 26px;
    height: 26px;
    background: #fff;
    border: 1px solid #DDDEE1;
    text-align: center;
    line-height: 26px;
    border-radius: 2px;
  }
  .tip{
    display: inline-block;
    width: 90px;
    position: absolute;
    background-color: #474E5D;
    font-size: 12px;
    line-height: 25px;
    color: white;
    top: -34px;
    right: -30px;
    visibility: hidden;
  }
  .tip::after{
    content: '';
    display: inline-block;
    border-top: 8px solid #474E5D;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    position: absolute;
    bottom: -7px;
    left: 40px;
  }
  .tip2{
    display: inline-block;
    width: 90px;
    position: absolute;
    background-color: #474E5D;
    font-size: 12px;
    line-height: 25px;
    color: white;
    top: -34px;
    right: -30px;
    visibility: hidden;
  }
  .tip2::after{
    content: '';
    display: inline-block;
    border-top: 8px solid #474E5D;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    position: absolute;
    bottom: -7px;
    left: 40px;
  }
  .item1:hover .tip{
    visibility: visible;
  }
  .item2:hover .tip2{
    visibility: visible;
  }
  .item2:hover{
    color:#CFA868 ;
  }
  .item1:hover{
    color:#CFA868 ;
  }

  .opreate-item{
    display: inline-block;
    /*width: 60px;*/
    text-align: center;
    position: relative;
  }
  .square .circle{
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    background: url('../../../../../assets/invite@2x.png');
    background-size: 100%;

  }
  .square .circle:hover{
    background: url('../../../../../assets/invite-hover@2x.png');
    background-size: 100%;
  }

  .operate-buttons{
    display: inline-block;
    position: absolute;
    font-size: 0;
    right: 15px;
    bottom: -13px;
    /*border: 1px solid #DDDEE1;*/
  }
  img {
    width: 100%;
    height: auto;
  }
</style>
